bovoApp.controller('MarketplaceStatusMappingController', ['$scope', 'Marketplace',
    function ($scope, Marketplace) {
        $scope.f = { provider: 'all', external_status: '', is_active: '' };
        $scope.mappings = [];
        $scope.missing = [];
        $scope.workSteps = [];
        $scope.mapping = null;
        $scope.loading = false;

        $scope.load = function () {
            var params = {};
            if ($scope.f.provider && $scope.f.provider !== 'all') params.provider = $scope.f.provider;
            if ($scope.f.external_status) params.external_status = $scope.f.external_status;
            if ($scope.f.is_active !== '') params.is_active = $scope.f.is_active;

            $scope.loading = true;
            Marketplace.statusMappings(params).success(function (res) {
                $scope.mappings = res.data || [];
                $scope.loading = false;
            }).error(function () {
                $scope.loading = false;
            });
        };

        $scope.loadWorkSteps = function () {
            Marketplace.workSteps().success(function (res) {
                $scope.workSteps = res.data || [];
            });
        };

        $scope.loadMissing = function () {
            var params = {};
            if ($scope.f.provider && $scope.f.provider !== 'all') {
                // Backend MissingThirdPartyStatus.third_party alani UPPERCASE — controller strtoupper yapiyor
                params.third_party = $scope.f.provider;
            }
            Marketplace.missingStatuses(params).success(function (res) {
                $scope.missing = res.data || [];
            });
        };

        // ============ CREATE / EDIT ============
        $scope.newMapping = function (prefill) {
            $scope.mapping = angular.extend({
                provider: '',
                external_status: '',
                external_sub_status: '',
                bovo_work_step_value: '',
                condition_key: '',
                condition_value: '',
                priority: 0,
                is_active: true,
                notes: ''
            }, prefill || {});
            $('#statusMappingModal').modal('show');
        };

        $scope.editMapping = function (item) {
            $scope.mapping = angular.copy(item);
            $('#statusMappingModal').modal('show');
        };

        $scope.saveMapping = function () {
            var m = $scope.mapping;
            if (!m.provider || !m.external_status) {
                Messenger().post({ message: 'Provider ve External Status zorunlu', type: 'error' });
                return;
            }

            // Bos string yerine null gonderelim (DB unique key dogru calissin)
            var payload = angular.copy(m);
            ['external_sub_status', 'condition_key', 'condition_value'].forEach(function (k) {
                if (payload[k] === '' || payload[k] === undefined) payload[k] = null;
            });

            var req = m.id
                ? Marketplace.updateStatusMapping(m.id, payload)
                : Marketplace.saveStatusMapping(payload);

            req.success(function (res) {
                Messenger().post(res.message || 'Kaydedildi');
                $('#statusMappingModal').modal('hide');
                $scope.load();
            }).error(function (res) {
                Messenger().post({ message: (res && res.message) || 'Kaydedilemedi', type: 'error' });
            });
        };

        // ============ DELETE ============
        $scope.confirmDelete = function (item) {
            $scope.mapping = item;
            $scope.deleteTarget = item.id;
            $('#delete').modal('show');
        };

        $scope.delete = function (type) {
            if (type !== 'delete') return;
            Marketplace.deleteStatusMapping($scope.deleteTarget).success(function (res) {
                Messenger().post(res.message || 'Silindi');
                $('#delete').modal('hide');
                $scope.load();
            }).error(function (res) {
                Messenger().post({ message: (res && res.message) || 'Silinemedi', type: 'error' });
            });
        };

        // ============ MISSING → NEW MAPPING ============
        $scope.createFromMissing = function (item) {
            // third_party alani uppercase, provider lowercase: normalize
            var provider = (item.third_party || '').toLowerCase();
            $scope.newMapping({
                provider: provider,
                external_status: item.third_party_status_key,
                priority: 0
            });
        };

        $scope.init = function () {
            $scope.loadWorkSteps();
            $scope.load();
            $scope.loadMissing();
        };
    }
]);
